import FormSection from '@/components/sections/form-section'
import FullheightMedia from '@/components/sections/fullheight-media'
import FullscreenCard from '@/components/sections/fullscreen-card'
import FullscreenMedia from '@/components/sections/fullscreen-media'
import Hero from '@/components/sections/hero'
import MediaCard from '@/components/sections/media-card'
import MediaParallax from '@/components/sections/media-parallax'
import MediaText from '@/components/sections/media-text'
import Menu from '@/components/sections/menu'
import SingleMedia from '@/components/sections/single-media'
import SingleParagraph from '@/components/sections/single-paragraph'
import Spacer from '@/components/sections/spacer'

export const sectionsMap: any = {
  'fullheight-media': FullheightMedia,
  'fullscreen-card': FullscreenCard,
  'fullscreen-media': FullscreenMedia,
  hero: Hero,
  'media-card': MediaCard,
  'media-parallax': MediaParallax,
  'media-text': MediaText,
  'single-media': SingleMedia,
  'single-paragraph': SingleParagraph,
  spacer: Spacer,
  menu: Menu,
  form: FormSection
}
